import axios from 'axios';
import {
	ACK_ACTIVE_ALARM,
	ACK_ACTIVE_ALARM_FAIL,
	ACK_ACTIVE_ALARM_SUCCESS,
	// ACK_SUCCESS_MSG,
	ALARMS_COUNT_REQUEST_GET,
	ALARMS_COUNT_RESPONSE_GET_FAIL,
	ALARMS_COUNT_RESPONSE_GET_SUCCESS,
	ALARMS_NOTIFICATION_DISABLE_REQUEST_FAIL,
	ALARMS_NOTIFICATION_DISABLE_REQUEST_SUCCESS,
	ALARMS_NOTIFICATION_DISABLE_REQUEST_UPDATE,
	EMAIL_RECEPIENT_REQUEST_EDIT,
	EMAIL_RECEPIENT_RESPONSE_EDIT_FAIL,
	EMAIL_RECEPIENT_RESPONSE_EDIT_SUCCESS,
	GET_ACTIVE_ALARMS,
	GET_ACTIVE_ALARMS_CRITICAL,
	GET_ACTIVE_ALARMS_CRITICAL_FAIL,
	GET_ACTIVE_ALARMS_CRITICAL_SUCCESS,
	GET_ACTIVE_ALARMS_FAIL,
	GET_ACTIVE_ALARMS_MAJOR,
	GET_ACTIVE_ALARMS_MAJOR_FAIL,
	GET_ACTIVE_ALARMS_MAJOR_SUCCESS,
	GET_ACTIVE_ALARMS_MINOR,
	GET_ACTIVE_ALARMS_MINOR_FAIL,
	GET_ACTIVE_ALARMS_MINOR_SUCCESS,
	GET_ACTIVE_ALARMS_SUCCESS,
	GET_ADMIN_ACCOUNT_DETAILS,
	GET_ADMIN_ACCOUNT_DETAILS_FAIL,
	GET_ADMIN_ACCOUNT_DETAILS_SUCCESS,
} from '../../constants/maintenance/activeAlarmsConstants';
import {
	ACCOUNTS_ADMIN_DETAILS,
	ALARM_ACK_API,
	API_RESPONSE_SUCCESS_STATUS_CODE,
	AUTH_TOKEN_ERROR_STATUS_CODE,
	// AUTH_TOKEN_ERROR_STATUS_MSG,
	BAD_REQUEST_ERROR_CODE,
	DEVICE_ALARMS_COUNT,
	ENDPOINT_URL,
	GET_ACTIVE_ALARMS_API,
	GET_AP_ALARMS,
	INTERNAL_SERVER_ERROR_STATUS,
	TOKEN_FAILED,
	UPDATE_NEWPASSWORD__API,
	UPDATE_PROFILE_LIST,
} from '../../constants/commonConstants';
import { decryptData, encryptData } from '../../utils/crypto';
import { logout } from '../userActions';
import { getCookie } from '../../utils/cookieHelper';
import { getBannerZTPDetails } from '../bannerAction';

/* Action creator for listing active alarms.
 *
 * This function asynchronously dispatches actions to fetch a list of active alarms.
 * It sends a request to the server with optional parameters such as limit and offset.
 * Upon successful response, it dispatches an action with the retrieved data.
 *
 * @param {number} [limit=50] - Optional parameter specifying the maximum number of user entries to fetch.
 * @param {number} [offset=0] - Optional parameter specifying the page no. to fetch the entries from that particular page.
 * @return {function} - Asynchronous function that dispatches actions based on the API response.
 */
export const listActiveAlarms =
	(limit = 50, offset = 0, search, filters = {}, selectAllSitesInDb) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: GET_ACTIVE_ALARMS,
			});

			const { } = getState();

			let baseUrl =
				ENDPOINT_URL +
				GET_ACTIVE_ALARMS_API +
				'?limit=' +
				limit +
				'&offset=' +
				offset;
			// let method;
			// if (filters && Object.keys(filters).length > 0) {
			// 	method = 'post';
			// }else if(search){
			// 	method = 'post'
			// } else {
			// 	method = 'post';
			// }
			
			if (search) {
				baseUrl = baseUrl + '&search=' + search;
			}
			if (selectAllSitesInDb) {
				baseUrl = baseUrl + '&selectall=true';
			}

			const config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: baseUrl,
			};
			// if (method === 'post') {
			const jsonData = JSON.stringify(filters);
			const ciphertext = encryptData(jsonData);
			config['data'] = ciphertext;
			// }

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			if (data) {
				dispatch({
					type: GET_ACTIVE_ALARMS_SUCCESS,
					payload: data,
				});
				return data;
			}
			if (data?.status && data.status === AUTH_TOKEN_ERROR_STATUS_CODE) {
				dispatch({
					type: GET_ACTIVE_ALARMS_FAIL,
					payload: TOKEN_FAILED,
				});
			}
		} catch (error) {
			console.log('error ', error);

			dispatch({
				type: GET_ACTIVE_ALARMS_FAIL,
				payload: 'Error fetching Active Alarms list',
			});
		}
	};
export const criticalActiveAlarms =
	(limit = 50, filters) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: GET_ACTIVE_ALARMS_CRITICAL,
			});

			const { } = getState();

			const baseUrl =
				ENDPOINT_URL +
				GET_ACTIVE_ALARMS_API +
				'?limit=' +
				limit +
				'&severity=1';

			const config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: baseUrl,
			};
			const jsonData = JSON.stringify(filters);
			const ciphertext = encryptData(jsonData);
			config['data'] = ciphertext;
			const encryptDataResp = await axios.request(config);
			const jsonString = decryptData(encryptDataResp.data);
			const data = JSON.parse(jsonString);
			const finalResponse = data;

			if (finalResponse) {
				dispatch({
					type: GET_ACTIVE_ALARMS_CRITICAL_SUCCESS,
					payload: finalResponse,
				});
			}
			if (
				finalResponse?.status &&
				finalResponse.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: GET_ACTIVE_ALARMS_CRITICAL_FAIL,
					payload: TOKEN_FAILED,
				});
			}
		} catch (error) {
			console.log('error ', error);

			dispatch({
				type: GET_ACTIVE_ALARMS_CRITICAL_FAIL,
				payload: 'Error fetching Active Alarms list',
			});
		}
	};
export const majorActiveAlarms =
	(limit = 50, filters) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: GET_ACTIVE_ALARMS_MAJOR,
			});
			const { } = getState();

			const config = {
				method: 'post',
				maxBodyLength: Infinity,
				url:
					ENDPOINT_URL +
					GET_ACTIVE_ALARMS_API +
					'?limit=' +
					limit +
					'&severity=2',};
			const jsonData = JSON.stringify(filters);
			const ciphertext = encryptData(jsonData);
			config['data'] = ciphertext;
			const encryptDataResp = await axios.request(config);
			const jsonString = decryptData(encryptDataResp.data);
			const data = JSON.parse(jsonString);
			const finalResponse = data;

			if (finalResponse) {
				dispatch({
					type: GET_ACTIVE_ALARMS_MAJOR_SUCCESS,
					payload: finalResponse,
				});
			}
			if (
				finalResponse?.status &&
				finalResponse.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: GET_ACTIVE_ALARMS_MAJOR_FAIL,
					payload: TOKEN_FAILED,
				});
			}
		} catch (error) {
			console.log('error ', error);

			dispatch({
				type: GET_ACTIVE_ALARMS_MAJOR_FAIL,
				payload: 'Error fetching Active Alarms list',
			});
		}
	};
export const minorActiveAlarms =
	(limit = 50, filters) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: GET_ACTIVE_ALARMS_MINOR,
			});

			const { } = getState();

			const config = {
				method: 'post',
				maxBodyLength: Infinity,
				url:
					ENDPOINT_URL +
					GET_ACTIVE_ALARMS_API +
					'?limit=' +
					limit +
					'&severity=3',};
			const jsonData = JSON.stringify(filters);
			const ciphertext = encryptData(jsonData);
			config['data'] = ciphertext;
			const encryptDataResp = await axios.request(config);
			const jsonString = decryptData(encryptDataResp.data);
			const data = JSON.parse(jsonString);
			const finalResponse = data;

			if (finalResponse) {
				dispatch({
					type: GET_ACTIVE_ALARMS_MINOR_SUCCESS,
					payload: finalResponse,
				});
			}
			if (
				finalResponse?.status &&
				finalResponse.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: GET_ACTIVE_ALARMS_MINOR_FAIL,
					payload: TOKEN_FAILED,
				});
			}
		} catch (error) {
			console.log('error ', error);

			dispatch({
				type: GET_ACTIVE_ALARMS_MINOR_FAIL,
				payload: 'Error fetching Active Alarms list',
			});
		}
	};

export const ackActiveAlarms =
	(payload = {}) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: ACK_ACTIVE_ALARM,
			});

			const { } = getState();

			const baseUrl = ENDPOINT_URL + ALARM_ACK_API;
			const jsonData = JSON.stringify(payload);
			const ciphertext = encryptData(jsonData);
			const config = {
				method: 'patch',
			maxBodyLength: Infinity,
			url: baseUrl,
			data: ciphertext,
		};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);

			if (
				data &&
				data.status === API_RESPONSE_SUCCESS_STATUS_CODE
				// data.msg === ACK_SUCCESS_MSG
			) {
				dispatch({
					type: ACK_ACTIVE_ALARM_SUCCESS,
					payload: data.msg,
				});
			}
			if (data?.status && data.status === AUTH_TOKEN_ERROR_STATUS_CODE) {
				dispatch({
					type: ACK_ACTIVE_ALARM_FAIL,
					payload: TOKEN_FAILED,
				});
			}
		} catch (error) {
			console.log('error ', error);

			dispatch({
				type: ACK_ACTIVE_ALARM_FAIL,
				payload: 'Error in acknowledging alarm',
			});
		}
	};

export const listActiveAlarmsForAp =
	(limit = 50, offset = 0, filters = {}, apSerial) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: GET_ACTIVE_ALARMS,
			});

			const { } = getState();

		const baseUrl = ENDPOINT_URL + GET_AP_ALARMS + apSerial + '/';
			const params = new URLSearchParams({ limit, offset });
			let method;
			if (filters && Object.keys(filters).length > 0) {
				method = 'post';
			} else {
				method = 'get';
			}

		const config = {
			method: method,
			maxBodyLength: Infinity,
			url: `${baseUrl}?${params.toString()}`,
		};
			if (method === 'post') {
				const jsonData = JSON.stringify(filters);
				const ciphertext = encryptData(jsonData);
				config['data'] = ciphertext;
			}

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log('alarms for ap', data);
			if (data) {
				dispatch({
					type: GET_ACTIVE_ALARMS_SUCCESS,
					payload: data,
				});
				return data;
			}
			if (data?.status && data.status === AUTH_TOKEN_ERROR_STATUS_CODE) {
				dispatch({
					type: GET_ACTIVE_ALARMS_FAIL,
					payload: TOKEN_FAILED,
				});
			}
		} catch (error) {
			console.log('error ', error);

			dispatch({
				type: GET_ACTIVE_ALARMS_FAIL,
				payload: 'Error fetching Active Alarms list',
			});
		}
	};
export const listAdminAccountsDetails =
	(limit = 50, offset = 0) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: GET_ADMIN_ACCOUNT_DETAILS,
			});

			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url:
					ENDPOINT_URL +
					ACCOUNTS_ADMIN_DETAILS +
					'?limit=' +
					limit +
					'&offset=' +
					offset,};

			const encryptDataResp = await axios.request(config);
			const jsonString = decryptData(encryptDataResp.data);
			const data = JSON.parse(jsonString);
			const finalResponse = data;
			console.log(finalResponse, 'final response');

			if (finalResponse && finalResponse.data) {
				dispatch({
					type: GET_ADMIN_ACCOUNT_DETAILS_SUCCESS,
					payload: finalResponse,
				});
			}
			if (
				finalResponse &&
				finalResponse.status &&
				finalResponse.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: GET_ADMIN_ACCOUNT_DETAILS_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
		} catch (error) {
			const message =
				error.response && error.response.finalResponse.message
					? error.response.finalResponse.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: GET_ADMIN_ACCOUNT_DETAILS_FAIL,
				payload: 'Error fetching admin account details list',
			});
		}
	};

export const updateAccountEmailRecepient =
	(payload) => async (dispatch, getState) => {
		try {
			// Dispatch request action
			dispatch({
				type: EMAIL_RECEPIENT_REQUEST_EDIT,
			});

			const { } = getState();
			console.log('payload here', payload);

			const adminId = Number(decryptData(getCookie('adminID')));
			let csrfToken = null;
			
			const bannerResponse = await dispatch(getBannerZTPDetails());
			const csrfEnabled = !!bannerResponse?.csrf_enabled && bannerResponse.csrf_enabled === 1;

			if (csrfEnabled) {
				try {
					const csrfUrl = `${ENDPOINT_URL}api/accounts/csrf/`;
					await axios.get(csrfUrl, {
						withCredentials: true,
					});
					csrfToken = getCookie('csrftoken');
				} catch (err) {
					console.error('Failed to fetch CSRF token:', err);
					throw new Error("CSRF protection is enabled, but token could not be fetched.");
				}
			}

		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);

		const headers = {};

		if (csrfToken) {
			headers['X-CSRFToken'] = csrfToken;
		}
		
		// Configure request
		const config = {
			method: 'patch',
		url: ENDPOINT_URL + UPDATE_NEWPASSWORD__API + `${adminId}/`,
		headers,
		data: ciphertext,
				...(csrfEnabled && { withCredentials: true }),
			};

			// Send request and get response
			let { data } = await axios.request(config);

			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			if (
				data &&
				data.data &&
				data.status === API_RESPONSE_SUCCESS_STATUS_CODE
			) {
				dispatch({
					type: EMAIL_RECEPIENT_RESPONSE_EDIT_SUCCESS,
					payload: {
						successMessageOnEdit: data.msg,
						editUserResponse: data.data},
				});
				dispatch(listAdminAccountsDetails());
			} else if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: EMAIL_RECEPIENT_RESPONSE_EDIT_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			} else if (
				data &&
				data.status &&
				(data.status === BAD_REQUEST_ERROR_CODE ||
					data.status === INTERNAL_SERVER_ERROR_STATUS) &&
				data.error
			) {
				console.log('in add fail,,', data);

				dispatch({
					type: EMAIL_RECEPIENT_RESPONSE_EDIT_FAIL,
					payload: data.error,
				});
			}
			// else if (data.errors) {
			//   const mappedErrors = mapErrors(data.errors);
			//   dispatch({
			//     type: TENANT_RESPONSE_EDIT_FAIL,
			//     payload: mappedErrors,
			//   });
			// }
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: EMAIL_RECEPIENT_RESPONSE_EDIT_FAIL,
				payload: message,
			});
		}
	};

export const devicesAlarmsCount =
	(limit = 50, offset = 0) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: ALARMS_COUNT_REQUEST_GET,
			});

			const { } = getState();

			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url:
					ENDPOINT_URL +
					DEVICE_ALARMS_COUNT +
					'?limit=' +
					limit +
					'&offset=' +
					offset,};

			const encryptDataResp = await axios.request(config);
			const jsonString = decryptData(encryptDataResp.data);
			const data = JSON.parse(jsonString);
			const finalResponse = data;
			console.log(finalResponse, 'final response');

			if (finalResponse && finalResponse.data) {
				dispatch({
					type: ALARMS_COUNT_RESPONSE_GET_SUCCESS,
					payload: finalResponse,
				});
			}
			if (
				finalResponse &&
				finalResponse.status &&
				finalResponse.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: ALARMS_COUNT_RESPONSE_GET_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
		} catch (error) {
			const message =
				error.response && error.response.finalResponse.message
					? error.response.finalResponse.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: ALARMS_COUNT_RESPONSE_GET_FAIL,
				payload: 'Error fetching alarms count',
			});
		}
	};

export const alarmsNotificationDisableUpdate =
	(body) => async (dispatch, getState) => {
		try {
			dispatch({
				type: ALARMS_NOTIFICATION_DISABLE_REQUEST_UPDATE,
			});
			const { } = getState();

			const adminId = Number(decryptData(getCookie('adminID')));

			let csrfToken = null;

			const bannerResponse = await dispatch(getBannerZTPDetails());
			const csrfEnabled = !!bannerResponse?.csrf_enabled && bannerResponse.csrf_enabled === 1;

			if (csrfEnabled) {
				try {
					const csrfUrl = `${ENDPOINT_URL}api/accounts/csrf/`;
					await axios.get(csrfUrl, {
						withCredentials: true,
					});
					csrfToken = getCookie('csrftoken');
				} catch (err) {
					console.error('Failed to fetch CSRF token:', err);
					throw new Error("CSRF protection is enabled, but token could not be fetched.");
				}
			}

	const jsonData = JSON.stringify(body);
	const ciphertext = encryptData(jsonData);

	const headers = {};

	if (csrfToken) {
		headers['X-CSRFToken'] = csrfToken;
	}

			const config = {
				method: 'patch',
				maxBodyLength: Infinity,
			url: ENDPOINT_URL + UPDATE_PROFILE_LIST + `${adminId}/`,
			headers,
				data: ciphertext,
				...(csrfEnabled && { withCredentials: true }),
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log('in get ap list...', data);
			if (
				data &&
				data.status &&
				data.status === API_RESPONSE_SUCCESS_STATUS_CODE
			) {
				dispatch({
					type: ALARMS_NOTIFICATION_DISABLE_REQUEST_SUCCESS,
					payload: data.data,
				});
			}
			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch(logout());
			}
			if (data && data.error) {
				dispatch({
					type: ALARMS_NOTIFICATION_DISABLE_REQUEST_FAIL,
					payload: data.error,
				});
			}
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch({
					type: ALARMS_NOTIFICATION_DISABLE_REQUEST_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
			return error;
		}
	};
